export const viewerPlaybackCopy = {
  en: {
    preparing: 'Preparing slide…',
    'scene-error':
      'This slide could not be rendered. Retry loading it, continue manually, or stop.',
    start: 'Start presentation with sound',
    replay: 'Replay narration',
    stop: 'Stop',
    volume: 'Volume',
    narrationProgress: 'Narration progress',
    timeline: 'Narration timeline',
    seek: 'Seek narration',
    presentationProgress: 'Presentation progress',
    transcript: 'Transcript',
    transcriptRegion: 'Slide transcript',
    controls: 'Playback controls',
    navigation: 'Slide navigation',
    deckPosition: 'Slide {{position}} of {{total}}',
    narrationTime: '{{elapsed}} of {{total}}',
    fullscreenUnavailable: 'Fullscreen is not available in this browser.',
    retry: 'Retry',
    manual: 'Continue manually',
    blocked: 'Your browser needs a Play gesture to start sound.',
    missing: 'This published slide has no ready narration. Continue manually or stop.',
    error: 'Narration could not be played. Check your connection or link access, then retry.',
    phase: {
      'waiting-slide': 'Preparing slide',
      'scene-error': 'Slide could not be rendered',
      idle: 'Ready to start',
      manual: 'Manual navigation',
      loading: 'Loading narration',
      playing: 'Playing narration',
      paused: 'Paused',
      'waiting-cues': 'Waiting for slide animations',
      blocked: 'Sound blocked',
      missing: 'Narration unavailable',
      error: 'Narration error',
      ended: 'Presentation finished',
    },
    settings: {
      label: 'Playback mode',
      INTERACTIVE: 'Interactive',
      NARRATED: 'Narrated Auto-play',
      interactiveHelp: 'Viewers navigate and play narration manually.',
      narratedHelp:
        'After Start, published narration and automatic slide navigation guide each viewer. Missing audio pauses playback.',
    },
  },
  fa: {
    preparing: 'در حال آماده‌سازی اسلاید…',
    'scene-error':
      'نمایش این اسلاید ممکن نشد. دوباره بارگیری کنید، دستی ادامه دهید یا پخش را پایان دهید.',
    start: 'شروع ارائه با صدا',
    replay: 'پخش دوبارهٔ روایت',
    stop: 'پایان پخش',
    volume: 'بلندی صدا',
    narrationProgress: 'پیشرفت روایت',
    timeline: 'خط زمان روایت',
    seek: 'جابه‌جایی در زمان روایت',
    presentationProgress: 'پیشرفت ارائه',
    transcript: 'متن روایت',
    transcriptRegion: 'متن روایت اسلاید',
    controls: 'کنترل‌های پخش',
    navigation: 'پیمایش اسلاید',
    deckPosition: 'اسلاید {{position}} از {{total}}',
    narrationTime: '{{elapsed}} از {{total}}',
    fullscreenUnavailable: 'نمایش تمام‌صفحه در این مرورگر در دسترس نیست.',
    retry: 'تلاش دوباره',
    manual: 'ادامهٔ دستی',
    blocked: 'برای شروع صدا، مرورگر به فشردن دکمهٔ پخش نیاز دارد.',
    missing: 'این اسلاید منتشرشده روایت آماده ندارد. دستی ادامه دهید یا پخش را پایان دهید.',
    error: 'پخش روایت ممکن نشد. اتصال یا دسترسی پیوند را بررسی و دوباره تلاش کنید.',
    phase: {
      'waiting-slide': 'آماده‌سازی اسلاید',
      'scene-error': 'نمایش اسلاید ممکن نشد',
      idle: 'آمادهٔ شروع',
      manual: 'پیمایش دستی',
      loading: 'بارگیری روایت',
      playing: 'در حال پخش روایت',
      paused: 'مکث',
      'waiting-cues': 'در انتظار پایان حرکت‌های اسلاید',
      blocked: 'صدا مسدود است',
      missing: 'روایت در دسترس نیست',
      error: 'خطای روایت',
      ended: 'ارائه پایان یافت',
    },
    settings: {
      label: 'حالت پخش',
      INTERACTIVE: 'تعاملی',
      NARRATED: 'پخش خودکار با روایت',
      interactiveHelp: 'بیننده اسلایدها و روایت را دستی کنترل می‌کند.',
      narratedHelp:
        'پس از شروع، روایت منتشرشده و پیمایش خودکار هر بیننده را راهنمایی می‌کنند. نبود صدا پخش را متوقف می‌کند.',
    },
  },
};
